import { css } from "@/utils/css";
import { useState } from "@wordpress/element";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";

type Props = {
    label?: string;
    help?: string;
    value?: string;
    defaultValue?: string;
    onChange?: (color: string) => void;
    className?: string;
};

export function ColorInput({ label, help, value, defaultValue, onChange, className }: Props) {
    const textId = uuid();
    const colorId = uuid();

    const [color, setColor] = useState(value || defaultValue);

    const handleColorChange = (color: string) => {
        setColor(color);
        onChange?.(color);
    };

    return (
        <label htmlFor={textId} className={css(className || "")}>
            {label && <span className={css("form-label")}>{label}</span>}

            <div className={css("color-input")} tabIndex={0}>
                <label htmlFor={colorId} className={css("preview")} style={{ backgroundColor: color }}>
                    <input id={colorId} type="color" value={color} onChange={(e) => handleColorChange(e.target.value)} />
                </label>

                <input id={textId} type="text" value={color} onChange={(e) => handleColorChange(e.target.value)} />

                {defaultValue && (
                    <button
                        className={css("reset")}
                        disabled={color === defaultValue}
                        onClick={() => handleColorChange(defaultValue)}
                        title={__("Reset to default color", "antimanual")}
                    >
                        <FaArrowRotateLeft />
                    </button>
                )}
            </div>

            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
